<template>
  <div class="app-checkout-summary">
    <div class="summary--header"><slot name="txtHeadline"><h2>Lorem ipsum</h2></slot></div>
    <div class="summary--body">
      <div class="mnp-data card">
        <MNP
          :process="process"
          :simType="simData.simType"
        >
          <template v-for="slot in possibleChildSlotsFor('Mnp')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MNP>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonMnp')" @click="$emit('onStepClick', 'mnpData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div class="customer-data card">
        <Customer
          :process="process"
          :simType="simData.simType"
          class="customer-summary-content"
        >
          <template v-for="slot in possibleChildSlotsFor('Customer')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Customer>
      </div>
      <div class="card card--info">
        <slot :name="'txtInfo' + simData.simType"></slot>
      </div>
      <div class="summary--cart">
        <Cart :targetTariff="targetTariff"
              :promoBenefits="promoBenefits"
              :prevPromotions="prevPromotions"
              :newTariffSelected="newTariffSelected" class="card">
          <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Cart>
      </div>
      <div class="summary--consents">
        <form>
          <ConsentWrapper
            ref="consentWrapper"
            :consentAGB.sync="consent.agb"
            :selectedNumberPortingConsent.sync="consent.porting"
          >
            <template v-for="slot in possibleChildSlotsFor('Consent')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </ConsentWrapper>
        </form>
      </div>
    </div>
    <Stepper
      :loading-next="loading"
      :show-prev="true"
      @prev="$emit('goBack')"
      @next="order()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import Stepper from '@/components/generic/Stepper.vue'
import MNP from '@/components/checkout/belatedPorting/summary/Mnp.vue'
import Cart from '@/components/checkout/belatedPorting/Cart.vue'
import Customer from '@/components/checkout/belatedPorting/summary/Customer.vue'
import trackingHandler from '@/mixins/trackingHandler'
import ConsentWrapper from '@/components/checkout/belatedPorting/summary/ConsentWrapper.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import transformElements from '@/mixins/transformElements'

export default {
  name: 'Summary',
  components: {
    ConsentWrapper,
    Customer,
    Cart,
    Stepper,
    MNP
  },
  data () {
    return {
      loading: false,
      consent: {
        agb: false, // is always true implicitly
        porting: false
      }
    }
  },
  mounted () {
    this.startLoader()
    this.transformDivToLink('link_contract_summary')
    this.stopLoader()
  },
  props: {
    process: {
      type: String,
      default: 'belatedPorting'
    },
    promoBenefits: {
      type: Object,
      default: null
    },
    targetTariff: {
      type: Object,
      default: null
    },
    newTariffSelected: {
      type: Boolean,
      default: false
    },
    prevPromotions: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    trackingHandler,
    validationFlow,
    transformElements
  ],
  methods: {
    async initiate () {
      this.startLoader()
      try {
        await this.$store.dispatch(`checkoutv2/${this.process}/initiate`)
      } catch (error) {
        this.errorToast(this.getErrorMessage(error))
        this.triggerErrorTracking(error)
      } finally {
        this.stopLoader()
      }
    },
    order () {
      this.$refs.consentWrapper.validate()

      if (this.consent.porting) {
        this.showBackendError = false
        this.startLoader()

        const successUrl = this.getSlotText('urlSuccess')

        this.$store
          .dispatch(`checkoutv2/${this.process}/confirm`, this.consent)
          .then(() => {
            window.location.href = successUrl
          })
          .catch((error) => {
            this.errorToast(this.getErrorMessage(error))
            this.triggerErrorTracking(error)
          })
          .finally(() => {
            this.stopLoader()
          })
      } else {
        this.vFlowScrollToFirstElemment()
        this.vFlowGetFirstErrorElementName().then((result) => {
          this.triggerValidationErrorTracking(result)
        })
      }

      return true
    }
  },
  computed: {
    identData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_identData/identData'] || null
    },
    portingData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/portingData'] || null
    },
    provider () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/provider'] || null
    },
    simData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_simData/simData'] || null
    }
  }
}
</script>
